import React from "react";

import TitleBar from "../component/TitleBar";
import Header from "../common/Header";
import Footer from "../common/Footer";
import FaqSlider from "../component/FaqSlider";

import { BsChevronRight } from "react-icons/bs";

function Faq() {

    return(
        <>
          <TitleBar title="FAQ" />
          <Header></Header>
          <FaqSlider></FaqSlider>

          <div className="faq-wrap">
            <div className="container">
                <div className="faq-group">
                    <h2 className="title">Treatments faq</h2>
                    <div className="row">
                        <div className="col-sm-6 col-lg-4 faq-single">
                            <div className="faq-block">
                            <h3>How long do lip injections last?</h3>
                            <p>Lip fillers aren’t permanent and dissolve naturally over time. Depending on which filler you choose, the results of the injections can last from six months to over a year. Your injector will help you decide which product is best for the results you’re looking for.</p>
                            <p className="faq-more"><a href="">More Detail <BsChevronRight/></a></p>
                            </div>
                        </div>
                        <div className="col-sm-6 col-lg-4 faq-single">
                            <div className="faq-block">
                            <h3>How long do lip injections last?</h3>
                            <p>Lip fillers aren’t permanent and dissolve naturally over time. Depending on which filler you choose, the results of the injections can last from six months to over a year. Your injector will help you decide which product is best for the results you’re looking for.</p>
                            <p className="faq-more"><a href="">More Detail <BsChevronRight/></a></p>
                            </div>
                        </div>
                        <div className="col-sm-6 col-lg-4 faq-single">
                            <div className="faq-block">
                            <h3>How long do lip injections last?</h3>
                            <p>Lip fillers aren’t permanent and dissolve naturally over time. Depending on which filler you choose, the results of the injections can last from six months to over a year. Your injector will help you decide which product is best for the results you’re looking for.</p>
                            <p className="faq-more"><a href="">More Detail <BsChevronRight/></a></p>
                            </div>
                        </div>
                        <div className="col-sm-6 col-lg-4 faq-single">
                            <div className="faq-block">
                            <h3>How long do lip injections last?</h3>
                            <p>Lip fillers aren’t permanent and dissolve naturally over time. Depending on which filler you choose, the results of the injections can last from six months to over a year. Your injector will help you decide which product is best for the results you’re looking for.</p>
                            <p className="faq-more"><a href="">More Detail <BsChevronRight/></a></p>
                            </div>
                        </div>
                        <div className="col-sm-6 col-lg-4 faq-single">
                            <div className="faq-block">
                            <h3>How long do lip injections last?</h3>
                            <p>Lip fillers aren’t permanent and dissolve naturally over time. Depending on which filler you choose, the results of the injections can last from six months to over a year. Your injector will help you decide which product is best for the results you’re looking for.</p>
                            <p className="faq-more"><a href="">More Detail <BsChevronRight/></a></p>
                            </div>
                        </div>
                        <div className="col-sm-6 col-lg-4 faq-single">
                            <div className="faq-block">
                            <h3>How long do lip injections last?</h3>
                            <p>Lip fillers aren’t permanent and dissolve naturally over time. Depending on which filler you choose, the results of the injections can last from six months to over a year. Your injector will help you decide which product is best for the results you’re looking for.</p>
                            <p className="faq-more"><a href="">More Detail <BsChevronRight/></a></p>
                            </div>
                        </div>
                    </div>
                </div>



                <div className="faq-group">
                <h2 className="title">products faq</h2>
                    <div className="row">
                        <div className="col-sm-6 col-lg-4 faq-single">
                            <div className="faq-block">
                            <h3>How long do lip injections last?</h3>
                            <p>Lip fillers aren’t permanent and dissolve naturally over time. Depending on which filler you choose, the results of the injections can last from six months to over a year. Your injector will help you decide which product is best for the results you’re looking for.</p>
                            <p className="faq-more"><a href="">More Detail <BsChevronRight/></a></p>
                            </div>
                        </div>
                        <div className="col-sm-6 col-lg-4 faq-single">
                            <div className="faq-block">
                            <h3>How long do lip injections last?</h3>
                            <p>Lip fillers aren’t permanent and dissolve naturally over time. Depending on which filler you choose, the results of the injections can last from six months to over a year. Your injector will help you decide which product is best for the results you’re looking for.</p>
                            <p className="faq-more"><a href="">More Detail <BsChevronRight/></a></p>
                            </div>
                        </div>
                        <div className="col-sm-6 col-lg-4 faq-single">
                            <div className="faq-block">
                            <h3>How long do lip injections last?</h3>
                            <p>Lip fillers aren’t permanent and dissolve naturally over time. Depending on which filler you choose, the results of the injections can last from six months to over a year. Your injector will help you decide which product is best for the results you’re looking for.</p>
                            <p className="faq-more"><a href="">More Detail <BsChevronRight/></a></p>
                            </div>
                        </div>
                        <div className="col-sm-6 col-lg-4 faq-single">
                            <div className="faq-block">
                            <h3>How long do lip injections last?</h3>
                            <p>Lip fillers aren’t permanent and dissolve naturally over time. Depending on which filler you choose, the results of the injections can last from six months to over a year. Your injector will help you decide which product is best for the results you’re looking for.</p>
                            <p className="faq-more"><a href="">More Detail <BsChevronRight/></a></p>
                            </div>
                        </div>
                        <div className="col-sm-6 col-lg-4 faq-single">
                            <div className="faq-block">
                            <h3>How long do lip injections last?</h3>
                            <p>Lip fillers aren’t permanent and dissolve naturally over time. Depending on which filler you choose, the results of the injections can last from six months to over a year. Your injector will help you decide which product is best for the results you’re looking for.</p>
                            <p className="faq-more"><a href="">More Detail <BsChevronRight/></a></p>
                            </div>
                        </div>
                        <div className="col-sm-6 col-lg-4 faq-single">
                            <div className="faq-block">
                            <h3>How long do lip injections last?</h3>
                            <p>Lip fillers aren’t permanent and dissolve naturally over time. Depending on which filler you choose, the results of the injections can last from six months to over a year. Your injector will help you decide which product is best for the results you’re looking for.</p>
                            <p className="faq-more"><a href="">More Detail <BsChevronRight/></a></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
          </div>

          <Footer></Footer>
        </>
    )
}

export default Faq;